import { useAtomValue, useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback, useEffect } from 'react';

import { isChatReadyAtom } from '../../../session';
import { useConversationCallbacks } from '../../chat';
import { activeConversationSidAtom, providerIsOnlineAtom, providerParticipantAtom } from '../../state';

export function useWaitingRoomConversation() {
  const waitingRoomConversationSid = useAtomValue(activeConversationSidAtom);
  const setProviderIsOnline = useSetAtom(providerIsOnlineAtom);
  const getProviderParticipant = useAtomCallback(useCallback((get) => get(providerParticipantAtom), []));

  const { joinConversation, leaveConversation } = useConversationCallbacks();
  const isChatReady = useAtomValue(isChatReadyAtom);

  useEffect(
    function handleInitWaitingRoomConversation() {
      async function joinWaitingRoomConversation() {
        if (isChatReady && waitingRoomConversationSid) {
          await joinConversation(waitingRoomConversationSid);

          const providerUser = await getProviderParticipant()?.getUser();
          setProviderIsOnline(!!providerUser?.isOnline);
          providerUser?.on('updated', ({ user: updatedUser }) => {
            setProviderIsOnline(updatedUser.isOnline);
          });
        }
      }
      joinWaitingRoomConversation();
      return () => {
        if (!waitingRoomConversationSid) return;
        leaveConversation(waitingRoomConversationSid);

        getProviderParticipant()
          ?.getUser()
          .then((updatedUser) => updatedUser?.removeAllListeners('updated'));
      };
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isChatReady, waitingRoomConversationSid],
  );
}
